import _ from "lodash";
import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { Loader, Dimmer } from "semantic-ui-react";
import { useAuth0 } from "@auth0/auth0-react";
import ProtectedRoute from "../private-route";
import { unprotectedRoutes, protectedRoutes } from "./route-defs";
import { isUserConsumer } from "../../utilities/auth";
import InstantInspection from "../instant-inspection/index";
import PlaceOrder from "../place-order/index";
import Login from "../login-form";
import InspectionType from "../inspection-type";
import NotFound from "../common/notfound";

const AppRoutes = () => {
  const { user, isAuthenticated } = useAuth0();
  const isConsumer = isUserConsumer(user);

  const renderRootElement = () => {
    if (isAuthenticated) {
      if (isConsumer) {
        return JSON.parse(localStorage.getItem("consumerSchema")) ? (
          <InspectionType />
        ) : (
          <InstantInspection />
        );
      } else {
        return <PlaceOrder />;
      }
    } else {
      return <Login />;
    }
  };

  return (
    <div className="workspace-frame">
      <Suspense
        fallback={
          <Dimmer active={true}>
            <Loader />
          </Dimmer>
        }
      >
        <Routes>
          <Route path="/" element={renderRootElement()} />
          {_.map(unprotectedRoutes, (route) => (
            <Route key={`route-${route.id}`} path={route.id} element={<route.component />} />
          ))}
          {_.map(protectedRoutes, (route) => (
            <Route key={`route-${route.id}`} path={route.id} element={<ProtectedRoute component={route.component} />} />
          ))}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </div>
  );
};

export default AppRoutes;
